import * as actions from './authActions';

const authReducers = {
  // DEPRECATED
  // [actions.AUTH_STORE_REDIRECT_LOCATION]: (state, { payload }) => {
  //   state.redirectLocation = payload;
  //   return state;
  // },
  [actions.AUTH_GETTING_SESSION]: state => {
    state.loading = true;
    return state;
  },
  [actions.AUTH_STORE_SESSION]: state => {
    state.loading = false;
    state.isAuthenticated = true;
    return state;
  },
  [actions.AUTH_CLEAR_SESSION]: state => {
    state.loading = false;
    delete state.userEmail;
    state.isAuthenticated = false;
    return state;
  },
  [actions.AUTH_STORE_SIGNIN_PARAMVALUE]: (state, { payload }) => {
    state.signInParamValue = payload;
    return state;
  },
  [actions.AUTH_CLEAR_SIGNIN_PARAMVALUE]: state => {
    delete state.signInParamValue;
    return state;
  },
  [actions.AUTH_STORE_IS_PERMITTED_TO_AUTHENTICATE_VIA_IDOLOGY]: (
    state,
    { payload }
  ) => {
    state.isPermittedToAuthenticateViaIdology = payload;
    return state;
  },
  [actions.AUTH_STORING_DEVICE_ID]: (state, { payload }) => {
    return {
      ...state,
      deviceId: payload,
    };
  },
  [actions.AUTH_STORE_SOCURE_SDK_KEYS]: (state, { payload }) => {
    return {
      ...state,
      ...payload,
    };
  },
};

export default {
  name: 'auth',
  reducers: authReducers,
  persist: {
    key: 'auth',
    whitelist: ['signInParamValue', 'isAuthenticated'],
  },
};
